import {
  OrderFulfillmentPending,
  OrderFulfillmentStatus,
  PreOrderFilledFilter
} from "@/interfaces/orderFulfillment";
import { EventBus, pusherEvents } from "@/internal";
import { SavedTableHeaders } from "@/metadata/orderFulfillment";
import { orderFulfillmentService } from "@/services/orderFulfillment.service";
import { FNS_DATE_FORMATS, fnsFormatDate } from "@/utils/date-fns.utils";
import {
  TableComponent,
  TableHeader,
  TablePagination,
  TablePaginationDefault
} from "helix-vue-components";
import pickBy from "lodash/pickBy";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TableOrderFulfillmentComponent } from "../tableOrderFulfillment/tableOrderFulfillment.component";
import Template from "./SavedOrders.template.vue";

@Component({
  mixins: [Template],
  components: {
    TableComponent,
    TableOrderFulfillmentComponent
  },
  inject: ["$changes"]
})
export class SavedOrdersComponent extends Vue {
  @Prop({ required: true }) public data!: {};
  @Prop({ required: true }) public filters!: PreOrderFilledFilter;
  @Prop({ default: "" }) public search!: string;
  @Prop({ default: false }) public onDisplay!: boolean;
  @Prop({ default: null }) public pharmacistSelected!: number | null;
  public saveData!: {};
  public pagination: TablePagination = { ...TablePaginationDefault };
  public loading = false;
  public headers = SavedTableHeaders;
  public orders: OrderFulfillmentPending[] = [];
  public statusOrders: { [key: string]: any } = OrderFulfillmentStatus;

  @Watch("filters")
  @Watch("search")
  public onFiltersChange() {
    this.pagination = {
      ...TablePaginationDefault,
      itemsPerPage: this.pagination.itemsPerPage
    };
    this.loadOrders();
  }

  public filter(header: TableHeader) {
    const h = header;
    const sort = `${!h.descending ? "-" : ""}${h.value || ""}`;
    this.loadOrders(sort);
  }
  public changePagination(pagination: TablePagination) {
    this.pagination = pagination;
    this.loadOrders();
  }

  /**
   * mounted : The mounted a native function from vuejs,
   * documentation: https://vuejs.org/v2/guide/instance.html
   */
  protected async mounted() {
    this.$changes.watch(pusherEvents.orderFulfillment, this.loadOrders);
    EventBus.$on("loadOrdersSaved", this.loadOrders);
    const unwatch = this.$watch("onDisplay", () => {
      this.loadOrders();
      unwatch();
    });
  }
  /**
   * Loads orders : Responsible for loading the list of accepted orders
   */
  private async loadOrders(sort?: string) {
    this.loading = true;
    const params = {
      status: this.statusOrders.ACCEPTED.toLowerCase(),
      pagination: this.pagination,
      sort,
      search: this.search
    };
    this.orders = (await orderFulfillmentService.getOrders(
      params,
      pickBy(this.filters)
    )).map(order => {
      const dateFromHour = order.pick_up_time_from
        ? fnsFormatDate(
            new Date(order.pick_up_time_from),
            FNS_DATE_FORMATS.EN_BARS_WITH_MERIDIEM_TIME
          )
        : "";

      const dateToHour = order.pick_up_time_to
        ? fnsFormatDate(new Date(order.pick_up_time_to), FNS_DATE_FORMATS.LT)
        : "";
      return {
        ...order,
        name: order.customer.name,
        customer: {
          ...order.customer,
          avatar: null
        },
        pick_up_date_range:
          dateFromHour && dateToHour ? `${dateFromHour} - ${dateToHour}` : ""
      };
    });
    this.pagination = await orderFulfillmentService.getPagination(true);
    this.$changes.watch(pusherEvents.orderFulfillment, this.loadOrders);
    this.$emit("inboxTotals", {
      quantity: this.pagination.totalItems,
      inbox: "filled"
    });
    this.loading = false;
  }
}
